module.exports = __webpack_public_path__ + "static/media/event-paused-illustration.c10a235d.svg";